// Lib
import React from 'react';

// Component
import CloseButton from '../../../../Button/CloseButton';

// Hooks
import useCountComponent from '../CountComponent/useCountComponent';
import { useStyles } from './CloseComponentStyles';

const CloseComponent = ({ orderItem, product, order, className }) => {
  const { classes, cx } = useStyles();
  const { onDelete } = useCountComponent(order, orderItem, product);

  return (
    <CloseButton className={cx(classes.button, className)} onClose={onDelete} />
  );
};

export default CloseComponent;
